/**
 * check if the window view port reach out the max width query
 * @return {boolean}
 */
export function isMobile(): boolean {
  return window.matchMedia('(max-width:600px)').matches;
}

/**
 * check if the window view port reach out the max width query
 * @return {boolean}
 */
export function isWideScreen(): boolean {
  return window.matchMedia('(max-width:1440px)').matches;
}
